import { Box } from "@mui/material";
import { memo } from "react";
import RecipeCardCompact from "../shared/RecipeCard";
import { LocalRecipe } from "./MealUtils";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
    recipes: LocalRecipe[];
    selection: Record<string, number>;
    onIncrement: (variantId: string) => void;
    onDecrement: (variantId: string) => void;
};

function MealRecipeGrid({ recipes, selection, onIncrement, onDecrement }: Props) {
    if (!recipes.length) {
        return (
            <Box
                sx={{
                    textAlign: "center",
                    py: 8,
                    color: QUIZ.color.brown,
                    fontFamily: QUIZ.font.body,
                }}
            >
                No recipes available for the selected pack size.
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
                gap: { xs: 2, md: 2.5 },
                mb: 4,
            }}
        >
            {recipes.map((recipe) => (
                <RecipeCardCompact
                    key={recipe.variantId}
                    recipe={recipe}
                    count={selection[recipe.variantId] ?? 0}
                    onIncrement={() => onIncrement(recipe.variantId)}
                    onDecrement={() => onDecrement(recipe.variantId)}
                />
            ))}
        </Box>
    );
}

export default memo(MealRecipeGrid);
